import { Box, Divider,  TextField, Typography, Autocomplete, FormControl, Stack } from "@mui/material";
import  { useState, useEffect } from "react";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import dayjs from "dayjs";


const ProductionBreakProcess = ({ rejectReelType }) => {
    // shift code 
    const [shiftCodes, setShiftCodes] = useState([]);
    const [selectedShiftCodes, setSelectedShiftCodes] = useState(null);
    const [shiftID, setShiftID] = useState(0);
    const [isMachineDataLoaded, setIsMachineDataLoaded] = useState(false);
    const [shiftDate, setShiftDate] = useState(dayjs());
    const [shiftStartTime, setShiftStartTime] = useState(dayjs());
    const [shiftEndTime, setShiftEndTime] = useState(dayjs());

    useEffect(() => {
        if (!isMachineDataLoaded) {
            const para = {
                p_companyid: 1,
                p_plantid: 1,
                p_product_type: rejectReelType,
            }
            fetch('http://localhost:3013/getRejectReasons', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(para)
            })
                .then(response => {
                    if (!response.ok) {
                        throw new Error('no data found');
                    }
                    return response.json();
                })
                .then(data => {

                    setShiftCodes(data);
                    setSelectedShiftCodes(data[0]);
                    setShiftID(data[0].id);
                })
                .catch(error => {
                    alert(error.message);
                });
        }
    }, [isMachineDataLoaded]);


    const handleShiftChange = (event, value) => {
        setSelectedShiftCodes(value);
        setShiftID(value.shiftid);
    }
    return (
        <Box>
            <Typography> Production Break</Typography>
            <Divider sx={{ marginTop: "10px" }} />
            <Box padding={2}>



                <Box
                    display="grid"
                    gridTemplateColumns={{
                        xs: 'repeat(2, 1fr)',
                        sm: 'repeat(2, 1fr)',
                        md: 'repeat(3, 1fr)',
                        lg: 'repeat(12, 1fr)',
                        xl: 'repeat(12, 1fr)',
                    }}
                    gridAutoRows="10px"
                    gap={{ xs: '40px', sm: '40px', md: '40px', lg: '10px', xl: '10px' }}
                >

                    <Box
                        gridColumn={{
                            xs: 'span 2',
                            sm: 'span 11',
                            md: 'span 11',
                            lg: 'span 4',
                            xl: 'span 4',
                        }}
                        display="flex"
                        alignItems="start"
                        justifyContent="start"
                    >
                        <Typography variant="h6">Production Break Type</Typography>
                    </Box>

                    <Box
                        gridColumn={{
                            xs: 'span 2',
                            sm: 'span 11',
                            md: 'span 11',
                            lg: 'span 8',
                            xl: 'span 8',
                        }}
                        display="flex"
                        alignItems="start"
                        justifyContent="start"

                    >

                        <TextField value={rejectReelType} sx={{ '& .MuiOutlinedInput-root': { '& fieldset': { borderStyle: 'dashed', } } }} fullWidth disabled type="text" size="small"></TextField>


                    </Box>

                </Box>




                <Box
                    display="grid"
                    gridTemplateColumns={{
                        xs: 'repeat(2, 1fr)',
                        sm: 'repeat(2, 1fr)',
                        md: 'repeat(3, 1fr)',
                        lg: 'repeat(12, 1fr)',
                        xl: 'repeat(12, 1fr)',
                    }}
                    gridAutoRows="10px"
                    marginTop={5}
                    marginBottom={5}
                    gap={{ xs: '40px', sm: '40px', md: '40px', lg: '10px', xl: '10px' }}
                >

                    <Box
                        gridColumn={{
                            xs: 'span 12',
                            sm: 'span 12',
                            md: 'span 12',
                            lg: 'span 4',
                            xl: 'span 4',
                        }}
                        display="flex"
                        alignItems="start"
                        justifyContent="start"
                    >
                        <Typography variant="h6">Break Reason</Typography>
                    </Box>

                    <Box
                        gridColumn={{
                            xs: 'span 12',
                            sm: 'span 12',
                            md: 'span 12',
                            lg: 'span 8',
                            xl: 'span 8',
                        }}
                        display="flex"
                        alignItems="start"
                        justifyContent="start"

                    >






                        <Autocomplete
                            fullWidth
                            value={selectedShiftCodes} // Use '' if sheeterSelectedChildRoll is empty or undefined
                            onChange={handleShiftChange}
                            size="small"

                            options={shiftCodes || []}
                            getOptionLabel={(option) => option?.reasons ?? ''}
                            renderInput={(params) => <TextField {...params} variant="outlined" />}
                        />

                    </Box>




                </Box>

           

                <Box
                    display="grid"
                    gridTemplateColumns={{
                        xs: 'repeat(2, 1fr)',
                        sm: 'repeat(2, 1fr)',
                        md: 'repeat(3, 1fr)',
                        lg: 'repeat(12, 1fr)',
                        xl: 'repeat(12, 1fr)',
                    }}
                    gridAutoRows="10px"
                    marginBottom={5}
                    gap={{ xs: '40px', sm: '40px', md: '40px', lg: '10px', xl: '10px' }}
                >

                    <Box
                        gridColumn={{
                            xs: 'span 2',
                            sm: 'span 11',
                            md: 'span 11',
                            lg: 'span 4',
                            xl: 'span 4',
                        }}
                        display="flex"
                        alignItems="start"
                        justifyContent="start"
                    >
                        <Typography variant="h6">Shift Date</Typography>
                    </Box>

                    <Box
                        gridColumn={{
                            xs: 'span 2',
                            sm: 'span 11',
                            md: 'span 11',
                            lg: 'span 8',
                            xl: 'span 8',
                        }}
                        display="flex"
                        alignItems="start"
                        justifyContent="start"

                    >

                        <FormControl fullWidth size="small">
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <Stack spacing={1} >
                                    <DatePicker
                                        // label="Today Date"
                                        value={dayjs(shiftDate)}
                                        onChange={(date) => setShiftDate(date)}
                                        slotProps={{ textField: { size: 'small' } }}
                                        fullWidth

                                        renderInput={(props) => (
                                            <TextField
                                                // helperText={shiftdate_errorMessage}
                                                // error={shiftdate_errorMessage && shiftdate_errorMessage.length ? true : false}
                                                {...props} />
                                        )}

                                    />
                                </Stack>
                            </LocalizationProvider>
                        </FormControl>


                    </Box>

                </Box>

                <Box
                    display="grid"
                    gridTemplateColumns={{
                        xs: 'repeat(2, 1fr)',
                        sm: 'repeat(2, 1fr)',
                        md: 'repeat(3, 1fr)',
                        lg: 'repeat(12, 1fr)',
                        xl: 'repeat(12, 1fr)',
                    }}
                    gridAutoRows="10px"
                    marginBottom={5}
                    gap={{ xs: '40px', sm: '40px', md: '40px', lg: '10px', xl: '10px' }}
                >

                    <Box
                        gridColumn={{
                            xs: 'span 2',
                            sm: 'span 11',
                            md: 'span 11',
                            lg: 'span 4',
                            xl: 'span 4',
                        }}
                        display="flex"
                        alignItems="start"
                        justifyContent="start"
                    >
                        <Typography variant="h6">Break Start</Typography>
                    </Box>

                    <Box
                        gridColumn={{
                            xs: 'span 2',
                            sm: 'span 11',
                            md: 'span 11',
                            lg: 'span 8',
                            xl: 'span 8',
                        }}
                        display="flex"
                        alignItems="start"
                        justifyContent="start"

                    >

                        <FormControl fullWidth size="small">
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <Stack spacing={1} >
                                    <TimePicker
                                        
                                        value={dayjs(shiftStartTime)}
                                        onChange={(date) => setShiftStartTime(date)}
                                        slotProps={{ textField: { size: 'small' } }}
                                        fullWidth                                     

                                    />
                                </Stack>
                            </LocalizationProvider>
                        </FormControl>


                    </Box>

                </Box>

                
                <Box
                    display="grid"
                    gridTemplateColumns={{
                        xs: 'repeat(2, 1fr)',
                        sm: 'repeat(2, 1fr)',
                        md: 'repeat(3, 1fr)',
                        lg: 'repeat(12, 1fr)',
                        xl: 'repeat(12, 1fr)',
                    }}
                    gridAutoRows="10px"
                    marginBottom={5}
                    gap={{ xs: '40px', sm: '40px', md: '40px', lg: '10px', xl: '10px' }}
                >

                    <Box
                        gridColumn={{
                            xs: 'span 2',
                            sm: 'span 11',
                            md: 'span 11',
                            lg: 'span 4',
                            xl: 'span 4',
                        }}
                        display="flex"
                        alignItems="start"
                        justifyContent="start"
                    >
                        <Typography variant="h6">Break End</Typography>
                    </Box>

                    <Box
                        gridColumn={{
                            xs: 'span 2',
                            sm: 'span 11',
                            md: 'span 11',
                            lg: 'span 8',
                            xl: 'span 8',
                        }}
                        display="flex"
                        alignItems="start"
                        justifyContent="start"

                    >

                        <FormControl fullWidth size="small">
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <Stack spacing={1} >
                                    <TimePicker
                                        
                                        value={dayjs(shiftEndTime)}
                                        onChange={(date) => setShiftEndTime(date)}
                                        slotProps={{ textField: { size: 'small' } }}
                                        fullWidth                                     

                                    />
                                </Stack>
                            </LocalizationProvider>
                        </FormControl>


                    </Box>

                </Box>

     <Box
                    display="grid"
                    gridTemplateColumns={{
                        xs: 'repeat(2, 1fr)',
                        sm: 'repeat(2, 1fr)',
                        md: 'repeat(3, 1fr)',
                        lg: 'repeat(12, 1fr)',
                        xl: 'repeat(12, 1fr)',
                    }}
                    gridAutoRows="10px"
                    marginBottom={5}
                    gap={{ xs: '40px', sm: '40px', md: '40px', lg: '10px', xl: '10px' }}
                >

                    <Box
                        gridColumn={{
                            xs: 'span 2',
                            sm: 'span 11',
                            md: 'span 11',
                            lg: 'span 4',
                            xl: 'span 4',
                        }}
                        display="flex"
                        alignItems="start"
                        justifyContent="start"
                    >
                        <Typography variant="h6">Remarks</Typography>
                    </Box>

                    <Box
                        gridColumn={{
                            xs: 'span 2',
                            sm: 'span 11',
                            md: 'span 11',
                            lg: 'span 8',
                            xl: 'span 8',
                        }}
                        display="flex"
                        alignItems="start"
                        justifyContent="start"

                    >

                        <TextField
                            sx={{ '& .MuiOutlinedInput-root': { '& fieldset': { borderStyle: 'dashed', } } }}
                            multiline
                            fullWidth
                            maxRows={4} type="text" size="small"></TextField>


                    </Box>

                </Box>


            </Box>
            <Divider />
        </Box>
    )
}
export default ProductionBreakProcess;